import * as T from "./types";

export const defaultState: T.Store = {
  tickers: [],
  selectedTicker: "",
  isBuy: true,
  meta: {
    country: []
  },
  metrics: [],
  status: {
    meta: "SUCCESS",
    tickers: "SUCCESS",
    tickerSummary: "SUCCESS",
    trade: "SUCCESS",
    delete: "SUCCESS",
    metrics: "SUCCESS"
  }
};
